import CryptoJS from 'crypto-js'

export const APIURL = 'https://services.kalpvruks.com/' // https://services.kalpvruks.com/      http://192.168.2.16:9512/

export const ACCORD_TOKEN = 'T8vjln1n2StO_BiPNwOaLoq2mXONSWTZ'

export const ACCORD_NEWAPI_URL = 'http://news.accordwebservices.com/'

export const ACCORD_WORLD_INDICES_URL = 'http://stock.accordwebservices.com/Stock/GetWorldIndices'

export const LTP_SOCKET_URL = 'wss://wss.kalpvruks.com'         //ws://14.195.72.131:9998   // ws://43.228.99.123:9998      // wss://wss.kalpvruks.com

export const SOCKET_CONNECT_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE4MTI1OTA3NzEsImRhdGEiOnsiQ0xJRU5USUQiOiIxQUcyNyIsIkFUeXBlIjoiQ0xJRU5UIiwiaXAiOiIifSwiaWF0IjoxNjkyNTkwODMxfQ.nqmaaQoWEtus3M4HBiE916k4xXCVJ8--MRPT_DuTI5I'

export const BOSS_APIURL = 'http://43.228.99.124:15000/'

export const BO_APIURL = 'http://192.168.2.16:7002/'

export const BRAIN_APIURL = 'http://192.168.2.16:2080/'

export function getCookie() {
    try {
        if (typeof document !== 'undefined' && typeof window !== 'undefined') {
            const cookies = typeof document !== 'undefined' && typeof window !== 'undefined' && document.cookie.split('; ');
            const cookieMap = {};
            cookies.forEach(cookie => {
                // Split on the FIRST '=' only. Destructuring split('=') discarded
                // everything after a second '=', so any cookie value containing
                // one came back truncated.
                const eq = cookie.indexOf('=');
                if (eq === -1) return;
                cookieMap[cookie.slice(0, eq)] = cookie.slice(eq + 1);
            });
            if (cookieMap["KalpUser"]) {
                return cookieMap
            } else {
                document.cookie = 'KalpUser=; Max-Age=-99999999; path=/;';
                window.location = "/login";
            }
        } else {
            document.cookie = 'KalpUser=; Max-Age=-99999999; path=/;';
            window.location = "/login";
        }
    } catch (error) {
        console.log(error)
    }
}

export function formatMoney(number) {
    let format = new Intl.NumberFormat('en-IN', {
        // style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
    });
    return format.format(number);
}

export function formatMoneyExpense(number) {
    let format = new Intl.NumberFormat('en-IN', {
        // style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
    });
    return format.format(parseInt(number));
}

export function numDifferentiation(value) {
    const val = Math.abs(value)
    if (val >= 10000000) return `${(value / 10000000).toFixed(2)} Cr`
    if (val >= 100000) return `${(value / 100000).toFixed(2)} Lac`
    return formatMoney(value);
}

export const UserLogout = async () => {
    // Redirect to login page
    // updateCookieKalpUser('')
    try { localStorage.removeItem('KalpSessionExpired') } catch (_) {}
    document.cookie = 'KalpUser=; Max-Age=-99999999; path=/;';
    window.location = "/login";
    // router.push('/login?x=x')
}


const LEGACY_SALT_SUFFIX = 'e59c151f-5c8c-4654-a7d4-c291185e2c59'

function evpBytesToKey(password, keyWords, ivWords) {
    let data = CryptoJS.lib.WordArray.create()
    let prev = CryptoJS.lib.WordArray.create()

    while (data.sigBytes < (keyWords + ivWords) * 4) {
        prev = CryptoJS.MD5(prev.clone().concat(CryptoJS.enc.Utf8.parse(password)))
        data.concat(prev)
    }

    return {
        key: CryptoJS.lib.WordArray.create(data.words.slice(0, keyWords), keyWords * 4),
        iv: CryptoJS.lib.WordArray.create(data.words.slice(keyWords, keyWords + ivWords), ivWords * 4),
    }
}

export async function EncryptedValue(value, salt = '') {
    const password = String(salt ?? '') + LEGACY_SALT_SUFFIX
    const { key, iv } = evpBytesToKey(password, 8, 4) // AES-256 key = 8 words, IV = 4 words

    const encrypted = CryptoJS.AES.encrypt(String(value), key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    })

    return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
}

export async function DecryptedValue(value, salt = '') {
    const password = String(salt ?? '') + LEGACY_SALT_SUFFIX
    const { key, iv } = evpBytesToKey(password, 8, 4)
    const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Hex.parse(String(value)) })

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    })

    return decrypted.toString(CryptoJS.enc.Utf8)
}
